<div class="custom-container">
  <div class="copyRight">2024 ©</div>
  <div class="version">
    <div *ngIf="isShowModalBtnVisible" [ngStyle]="{ backgroundColor: isProd ? 'red' : '', color: isProd ? 'white' : '' }" (click)="openModal()">{{ environMent }}</div>
    <div *ngIf="showVersion" (click)="counterChange()">{{ version }}</div>
  </div>
</div>
